module.exports = __webpack_public_path__ + "img/TurningStool2.83cac776.jpg";